import { IIngestion, IIngestionLogDetailsState } from './ingestion.interface';

export const ingestionLogDetailsInitialState: IIngestionLogDetailsState = {
  details: null,
  isLoading: false,
  hasError: false,

  isMessageExpanded: false,

  stage: null,
  dsName: null,
  tableName: null,
  fileName: null,
  level: '',
};

export const initialIngestionState: IIngestion = {
  ingestionLogDetails: ingestionLogDetailsInitialState,
  logFiltering: {
    searchTerm: '',
    statusId: null,
  },
  selectedLogId: null,
  selectedTreeItem: '',
  expandedTreeItems: [],
};
